import $ from 'jquery'
import _ from 'lodash'
import * as Store from './modules/store'
import * as ShareFunc from './modules/sharefunc'
import {Libs} from 'eyes-lib/es'

$(function(){

	/** 最近見たツアー表示 */
	drawRcentlyList(); 

	/** 最近見たツアーリストを作成 */
	createRcentlyList(); 

	/** お気に入り件数を取得 */
	const favInfo = ShareFunc.fav.getFavoriteCountInfo();
	$("#FavoriteCount").text(favInfo.size);

	/** お気に入り追加ボタンをクリック */
	$('#addFavorite').click(function() {
		/** @type {TourItem} 現在の商品情報を登録 */
		const shohinJson = _.get(window,"shohinJson");
		const shohin = getDetailClass(shohinJson)
		ShareFunc.fav.addFavoriteData(shohin, function(err, data){
			if('max' == err) {
				alert(`お気に入りに保存できる件数は${data.max}件までです`)
			} else if( 'already' == err ) {
				alert(`すでにお気に入りに保存されています`)
			} else {
				alert(`保存しました`)
				$("#FavoriteCount").text(ShareFunc.fav.getFavoriteCountInfo().size);
			}
		})
	})

	/** お気に入り削除ボタンをクリック */
	$('#delFavorite').click(function() {
		/** @type {TourItem} 現在の商品情報を登録 */
		const shohinJson = _.get(window,"shohinJson");
		const shohin = getDetailClass(shohinJson)
		ShareFunc.fav.delFavoriteData(shohin, function( err )
		{
			if( err )
				alert(`削除できませんでした`)
			else
				alert(`削除しました`)
				$("#FavoriteCount").text(ShareFunc.fav.getFavoriteCountInfo().size);
		})
	})
	

	/** お気に入り画面ボタンをクリック */
	$("body").on("click",".moveFavorite",function (e) {
		setFavorite()
		$('#ff').submit()
	})

});


/**
 * StoreのDetailDataにセットしローカルストレージへ保存
 *
 * @param {TourItem} jsonData
 */
function getDetailClass(jsonData){

	const shohin = Store.DetailData.new()

	shohin.tourcode = jsonData.tourcode
	shohin.branchcode = jsonData.branchcode
	shohin.title = jsonData.title
	shohin.subtitle = jsonData.subtitle
	shohin.termday = jsonData.termday
	shohin.minprice = jsonData.minprice
	shohin.maxprice = jsonData.maxprice
	shohin.tourimage = jsonData.tourimage
	shohin.headercode = jsonData.headercode

	return shohin;
}


/***********************************↓最近見たツアー↓*********************************** */

/** 最近見たツアー表示 */
function drawRcentlyList(){
	/** @type {Object.<string, any>} ストレージ全部 */
	const dataList = Store.App.storage.load()

	_.each(dataList,  function(value, key){

		/** 最近見たツアー用のストレージを抜粋 */
		if(key.indexOf("Rcently") >= 0){
			/** @type {import("./modules/store").DetailData} 詳細情報 */
			const rcentlyData = value;

			//HTML吐き出し
			drawDetailHtml(rcentlyData);

		}
	} );

}

/**
 * HTMLに吐き出し
 * 
 * @param {import("./modules/store").DetailData} detailData 
 */
function drawDetailHtml(detailData){

	const codes = detailData.tourcode.split("-");
	const code1 = codes[0];
	const code2 = codes[1];
	const code3 = codes[2];

	const html = `
	<!--/PopularPlan end-->
	<div class="RecentlyPlan">
		<a href="detail?c1=${code1}&c2=${code2}&c3=${code3}&br=${detailData.branchcode}&hcd=${detailData.headercode}">
			<h3>${detailData.title}</h3>
			<div class="PlanMain">
				<div class="Photo">
					<img src="${detailData.tourimage}" alt="">
				</div>
				<div class="SubInfo">
					<div class="TravelPeriod">${detailData.termday}</div>
					<!--/TravelPeriod end-->
					<div class="PlanPrice">
						<dl>
							<dt>旅行代金</dt>
							<dd>
								<ul>
									<li class="From">
										<span class="Price">${detailData.minprice}</span>
										<span class="Unit">円</span>
									</li>
									<li class="To">
										<span class="Price">${detailData.maxprice}</span>
										<span class="Unit">円</span>
									</li>
								</ul>
							</dd>
						</dl>
					</div>
					<!--/PlanPrice end-->
				</div>
				<!--/SubInfo end-->
				<div class="PlanCode">
					<span>コース番号</span>
					<span>${detailData.tourcode}</span>
				</div>
				<!--/PlanCode end-->
			</div>
			<!--/PlanBoxMain end-->
			<p class="SubTitle">${detailData.subtitle}</p>
		</a>
	</div>
	`
	$('#recently').append(html);

}


/**
 *最近見たツアーリストの作成
 */
function createRcentlyList(){

	/** @type {Object.<string, any>} 全ストレージ取得 */
	const dataList = Store.App.storage.load()


	//最初に現在の商品情報を登録
	var cnt=0;
	/** @type {TourItem} */
	const shohinJson = _.get(window,"shohinJson");
	const shohin = getDetailClass(shohinJson)
	Store.App.storage.setItem(`Rcently_${shohin.tourcode}_${shohin.branchcode}`, shohin)


	//登録済みから余分を省く
	_.each(dataList,  function(value, key){

		/** 最近見たツアー用のストレージを抜粋 */
		if(key.indexOf("Rcently") >= 0){
			/** @type {import("./modules/store").DetailData} 詳細情報 */
			const rcentlyData = value;

			const keyname = `Rcently_${rcentlyData.tourcode}_${rcentlyData.branchcode}`;
			if(cnt < 3){
				Store.App.storage.setItem(keyname, rcentlyData)
			}else{
				Store.App.storage.removeItem(keyname)
			}

			cnt++;
		}
	} )

}


/***********************************↑最近見たツアー↑*********************************** */

function setFavorite(){
	const favoriteCart = ShareFunc.fav.packFavoriteData()
	$("#favoritedata").val(JSON.stringify(favoriteCart))
}